import React, { useEffect } from 'react'
import { Button, Form, Input, Upload, InputNumber } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

const GoodsForm = ({ form, initialValues, onSubmit }) => {
  useEffect(() => {
    form.setFieldsValue(initialValues)
  }, [form, initialValues])

  return (
    <Form form={form} layout="vertical">
      <Form.Item
        name="category"
        label="category"
        rules={[{ required: true, message: 'Please enter the goods category' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="name"
        label="name"
        rules={[{ required: true, message: 'Please enter the goods name' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="zIndex" label="zIndex">
        <InputNumber min={0} defaultValue={1} />
      </Form.Item>

      <Form.Item
        name="price"
        label="Price"
        rules={[{ required: true, message: 'Please enter the goods price' }]}
      >
        <InputNumber min={0} />
      </Form.Item>

      <Form.Item
        name="imageFile"
        label="Image File"
        valuePropName="file"
        getValueFromEvent={e => e?.fileList?.[0] || null}
      >
        <Upload beforeUpload={() => false} maxCount={1} accept="image/*">
          <Button icon={<UploadOutlined />}>Иконка</Button>
        </Upload>
      </Form.Item>

      <Form.Item
        name="previewImage"
        label="Preview image"
        valuePropName="previewFile"
        getValueFromEvent={e => e?.fileList?.[0] || null}
      >
        <Upload beforeUpload={() => false} maxCount={1} accept="image/*">
          <Button icon={<UploadOutlined />}>Превью Иконка</Button>
        </Upload>
      </Form.Item>
    </Form>
  )
}

export default GoodsForm
